import { useTranslation } from "react-i18next";
import { MapNoAddress } from "./map-no-address.component";
import type { MapCenter, PharmacyMarker } from "./pharmacy-map.types";
import { PharmacyMapLazy } from "./pharmacy-map-lazy.component";

interface MapPreviewCardProps {
	center: MapCenter | null;
	pharmacyMarkers?: PharmacyMarker[];
	selectedPharmacyId?: number | null;
	onOpenFullMap?: () => void;
	isLoading?: boolean;
	onEnterAddress?: () => void;
}

export function MapPreviewCard({
	center,
	pharmacyMarkers,
	selectedPharmacyId,
	onOpenFullMap,
	isLoading = false,
	onEnterAddress,
}: MapPreviewCardProps) {
	const { t } = useTranslation("product");
	const hasPostalCode = center !== null;
	const showButton = hasPostalCode && !isLoading;

	// No address yet (and not just loading one): show the prompt instead of the
	// compact map preview.
	if (!hasPostalCode && !isLoading) {
		return <MapNoAddress variant="card" onEnterAddress={onEnterAddress} />;
	}

	return (
		<div className="w-full">
			<div className="relative h-[120px] w-full overflow-hidden rounded-md border border-gray-200">
				<PharmacyMapLazy
					center={center}
					pharmacyMarkers={pharmacyMarkers}
					selectedPharmacyId={selectedPharmacyId}
					interactive={false}
					isLoading={isLoading}
				/>
				{showButton && (
					<button
						type="button"
						className="absolute inset-0 flex flex-col items-center justify-center gap-2"
						onClick={onOpenFullMap}
						disabled={!onOpenFullMap}
					>
						<span className="px-2 py-1 text-body-sm-emphasis text-success-700 bg-success-50 rounded-xl">
							{t("vendor.map.findOnMap")}
						</span>
					</button>
				)}
			</div>
		</div>
	);
}
